import { useCopyToClipboard } from "@/hooks";
import { cn } from "@/lib/utils";
import { Check, Copy } from "lucide-react";

export function DeploymentUrl({
  url,
  className,
}: { url: string; className?: string }) {
  const { copyToClipboard, isCopied } = useCopyToClipboard();

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      copyToClipboard(url);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div
      className={cn("flex flex-1 items-center gap-2 justify-end", className)}
    >
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="transition-colors justify-end text-primary/80 hover:text-primary"
      >
        <span className="font-mono break-all underline">{url}</span>
      </a>

      <button
        type="button"
        onClick={handleCopy}
        className={cn("p-0.5 rounded-full transition-colors", {
          "hover:text-muted-foreground": !isCopied,
        })}
        title="Copy URL"
      >
        {isCopied ? (
          <Check className="w-4 h-4" />
        ) : (
          <Copy className="w-4 h-4" />
        )}
      </button>
    </div>
  );
}
